/** localStorage keys for staff admin session (keep in sync with axios client + auth store). */
export const AUTH_ACCESS_KEY = 'tb_admin_access_token'
export const AUTH_REFRESH_KEY = 'tb_admin_refresh_token'
export const AUTH_USER_KEY = 'tb_admin_user'
export const AUTH_OWNER_IMPERSONATION_KEY = 'tb_admin_owner_impersonation'
